import Swiper, { Pagination, Manipulation } from "swiper";
import { updateHoverSliders, addToGlobalThisRet, findControls } from "@plugins";

window.addEventListener("load", () => {
    initArticlesSlider();
    updateHoverSliders();
});

function initArticlesSlider() {
    const articlesOther = document.querySelector(".js-articles-other");

    if (articlesOther) {
        const controls = findControls(articlesOther, ".js-articles-other-controls");
        const articlesOtherSlider = articlesOther.querySelector(".js-articles-other-slider");

        new Swiper(articlesOtherSlider, {
            modules: [Pagination, Manipulation],
            slidesPerView: 1.7,
            spaceBetween: 16,
            pagination: {
                el: controls.pagination,
                clickable: true,
            },
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
            observer: true,
            watchOverflow: true,
            breakpoints: {
                406: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                567: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
            },
        });
    }
}

addToGlobalThisRet(initArticlesSlider, "initArticlesSlider");
